var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vx-card',{attrs:{"title":"Minimum Order Quantity"}},[_c('minimum-order-quantity')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }